<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
    <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <path fill="#DA1E27" fill-rule="nonzero" d="M10.647 17.249V10.75c.027-.714.626-1.273 1.34-1.25.696.023 1.268.557 1.338 1.25v6.5c-.027.713-.624 1.271-1.338 1.25-.697-.022-1.27-.557-1.34-1.251zM10.5 6.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5c.017.403-.136.794-.42 1.08-.286.284-.677.437-1.08.42-.403.017-.794-.136-1.08-.42-.284-.286-.437-.677-.42-1.08z"/>
        <circle cx="12" cy="12" r="12"/>
        <circle cx="12" cy="12" r="11" stroke="#DA1E27" stroke-width="2"/>
    </g>
</svg>
